import { API_URL } from "../utils/config";
import { createAsyncThunk } from '@reduxjs/toolkit';
import { getAuthToken } from "./getAuthToken";

export const fetchConstants = createAsyncThunk(
    'constants/fetchConstants',
    async (_, {rejectWithValue}) => {
    
    try {
        const token = getAuthToken();
        if (!token) {
            console.warn("User not authenticated, skipping API call.");
            return;
        }

        const response = await fetch(API_URL + '/constants', {
            headers: {
              Authorization: token, // Send token
            }
          });
  
        if(!response.ok) {
          if(response.status === 401) {
              return rejectWithValue({status: 401, message: 'Unauthorized'});
          }
          return rejectWithValue({status: response.status, message: 'API error'});
        }
        const data = await response.json();
        data.vehicleMakes.sort((a, b) => a.code.localeCompare(b.code));
        data.vehicleModels.sort((a, b) => a.name.localeCompare(b.name));
        data.completionCodes.sort((a, b) => a.name.localeCompare(b.name));
        return data;
    } catch (err) {
        return rejectWithValue({status: 0, message: 'Network error'});
    }
    }
  );